module.exports = __webpack_public_path__ + "static/media/Circle1.f2b9fce3.jpg";